import React, { useState } from "react";
import Select from "react-select";

const all = { label: "All", value: "" };

export default function CustonFilter({ name, label, gridController, lov, onChange, depend, selectedParent, parent }) {
  const [selectedValue, setSelectedValue] = useState(all);

  return (
    <>
      <label htmlFor={`filter-${name}`} className="invisible">
        {label}
      </label>
      <Select
        value={selectedValue}
        className="grid-reactSelect-wrapper"
        classNamePrefix="grid-reactSelect"
        id={`filter-id-${name}`}
        inputId={`filter-${name}`}
        data-id={`filter-${name}`}
        options={[all, ...lov]}
        name={name}
        defaultValue={all}
        menuPosition="absolute"
        menuPortalTarget={document.body}
        classNames={{
          option: () => `menu-item-${name}`
        }}
        onChange={(option) => {
          let filter = {};
          let l = true
          if (typeof onChange === "function") {
            onChange(option);
          }
          setSelectedValue(option);

          filter[name] = option?.value;
          if (depend) {
            filter[depend] = "";
          }
          if (parent) {
            filter[parent] = selectedParent;
          }
          if (depend && option.value !== "") {
            l = false
          }

          gridController.current.filterExternally(filter, l);
        }}
        styles={{ menuPortal: (base) => ({ ...base, minWidth: "10rem", zIndex: 999 }) }}
      />
    </>
  );
}
